import { useMemo } from "react";
import { flatten } from "./array";
import { notInfinity } from "./number";
import { forX } from "./for-x";
export const useVirtualItems = (
  items,
  contentSize,
  trackSize,
  offsets,
  infinite,
  offsetProp
) => {
  const pad = useMemo(() => {
    if (!infinite) {
      return 0;
    }
    return notInfinity(
      Math.max(
        1,
        trackSize[offsetProp]
          ? Math.ceil(Math.ceil(trackSize[offsetProp] / contentSize) / 2)
          : 1
      ),
      1
    );
  }, [contentSize, trackSize, offsetProp, infinite]);
  return useMemo(() => {
    const itemCount = items.length;
    return [
      ...forX(pad, pi =>
        items.map((item, i) => ({
          isClone: true,
          item,
          index: itemCount * (pad - pi) * -1 + i,
          realIndex: i,
          offset: contentSize * (pi + 1) * -1 + offsets[i]
        }))
      ).reduce(flatten, []),
      ...items.map((item, i) => ({
        isClone: false,
        item,
        index: i,
        realIndex: i,
        offset: offsets[i]
      })),
      ...forX(pad, pi =>
        items.map((item, i) => ({
          isClone: true,
          item,
          index: itemCount * (pad - pi) + i,
          realIndex: i,
          offset: contentSize * (pi + 1) + offsets[i]
        }))
      ).reduce(flatten, [])
    ];
  }, [items, pad, contentSize, offsets]);
};
